import * as React from "react";

export interface TestimonialDetailsProps {
  src: string;
  name: string;
  title: string;
  text: string;
}

const TestimonialDetails = (props: TestimonialDetailsProps) => (
  <div className="testimonial-detail-carousel__item">
    <div className="bubble">
      <h2>
        <strong>{props.name}</strong> - <span>{props.title}</span>
      </h2>
      <p>{props.text}</p>
    </div>
  </div>
);

export default TestimonialDetails;



// WEBPACK FOOTER //
// ./src/routes/TestimonialsCarousel/components/TestimonialDetails.tsx